import { fetchDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, VALUESTREAMID_PATH_PARAM } from 'constants/api';
import { formatBalance } from 'services/NumberFormatters';

export const getValueStreamDisplayData = async (valueStreamId, orgid) => {
    const fetchedValueStream = await fetchDataRequest('valueStreamDisplayData', [ORGID_PATH_PARAM, VALUESTREAMID_PATH_PARAM], [orgid, valueStreamId]) || [];
    return {
        id: fetchedValueStream?.id ? fetchedValueStream?.id : 0,
        name: fetchedValueStream?.name ? fetchedValueStream?.name : 'No name specified',
        description: fetchedValueStream?.description ? fetchedValueStream?.description : 'No description specified',
        valueProposition: fetchedValueStream?.valueProposition ? fetchedValueStream?.valueProposition : 'No value proposition specified',
        budget: fetchedValueStream?.budget ? formatBalance(fetchedValueStream?.budget) : formatBalance(0),
        kpi: fetchedValueStream?.kpi ? fetchedValueStream?.kpi : 'No KPI specified',
        systems: fetchedValueStream?.systems ? fetchedValueStream?.systems : 'No systems specified',
        owner: fetchedValueStream?.owner ? fetchedValueStream?.owner : 'No owner specified', 
        theme: fetchedValueStream?.theme ? fetchedValueStream?.theme : 'No theme specified', 
        portfolio: fetchedValueStream?.portfolioName ? fetchedValueStream?.portfolioName : 'No portfolio specified', 
    };
};

// temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)
export const getMockDrillDownData = () => {
    return [{ id: '2578cb65923bb7ba0845014820190617', name: 'fake team number 1', description: 'description number 1' }, { id: '9876cb65923bb7ba0845014820190617', name: 'fake team number 2', description: 'description number 1' }];
};





// WEBPACK FOOTER //
// ./services/valueStreamService.js